import { createSlice } from "@reduxjs/toolkit";
import {
  getGeneralProjects,
  getAllProjectsTypes,
  getSeasonalProjects,
  getDetailsProjects,
  getHomeProjects,
  getBranchProjects,
  getProjectBranches,
} from "../actions/projects.actions";

const initialState = {
  projects: [] as any,
  seasonalProjects: [] as any,
  generalProjects: [] as any,
  homeSeasonalProjects: [] as any,
  branchProjects: [] as any,
  detailsProject: {
    status: "idle",
    project: {} as any,
  },
  projectTypes: [] as any,
  projectBranches: [] as any,
  loading: false,
  statusProjects: "idle" as string,
  error: null as unknown | null,
};
export const projectsSlice = createSlice({
  name: "projects",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    /*--------------------------GET ALL Public PROJECTS---------------------------*/
    builder
      .addCase(getGeneralProjects.pending, (state) => {
        state.loading = true;
      })
      .addCase(getGeneralProjects.fulfilled, (state, action) => {
        state.projects = action.payload.result;
        state.loading = false;
      })
      .addCase(getGeneralProjects.rejected, (state, action) => {
        state.projects = [];
        state.loading = false;
        state.error = action.payload;
      })
      /*--------------------------GET ALL SEASONAL PROJECTS---------------------------*/
      .addCase(getSeasonalProjects.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSeasonalProjects.fulfilled, (state, action) => {
        state.seasonalProjects = action.payload.result;
        state.loading = false;
      })
      .addCase(getSeasonalProjects.rejected, (state, action) => {
        state.seasonalProjects = [];
        state.loading = false;
        state.error = action.payload;
      })
      /*--------------------------GET HOME PAGE SEASONAL PROJECTS---------------------------*/
      .addCase(getHomeProjects.pending, (state) => {
        state.statusProjects = "idle";
      })
      .addCase(getHomeProjects.fulfilled, (state, action) => {
        state.homeSeasonalProjects = action.payload.result;
        state.statusProjects = "succeeded";
      })
      .addCase(getHomeProjects.rejected, (state, action) => {
        state.homeSeasonalProjects = [];
        state.statusProjects = "rejected";
        state.error = action.payload;
      })
      /*--------------------------GET ALL PROJECTS TYPES ---------------------------*/
      .addCase(getAllProjectsTypes.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllProjectsTypes.fulfilled, (state, action) => {
        state.projectTypes = action.payload;
        state.loading = false;
      })
      .addCase(getAllProjectsTypes.rejected, (state, action) => {
        state.projectTypes = [];
        state.loading = false;
        state.error = action.payload;
      })
      /*--------------------------GET DETAILS OF PROJECTS---------------------------*/
      .addCase(getDetailsProjects.pending, (state) => {
        state.detailsProject.status = "loading";
      })
      .addCase(getDetailsProjects.fulfilled, (state, action) => {
        state.detailsProject.project = action.payload;
        state.detailsProject.status = "succeeded";
      })
      .addCase(getDetailsProjects.rejected, (state, action) => {
        state.detailsProject.project = {};
        state.error = action.payload;
      }) 
      /*--------------------------GET BRANCH PROJECTS ---------------------------*/
      .addCase(getBranchProjects.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBranchProjects.fulfilled, (state, action) => {
        state.branchProjects = action.payload.result;
        state.loading = false;
      })
      .addCase(getBranchProjects.rejected, (state, action) => {
        state.branchProjects = [];
        state.loading = false;
        state.error = action.payload;
      })
      /*--------------------------GET PROJECTS BRANCHES ---------------------------*/
      .addCase(getProjectBranches.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProjectBranches.fulfilled, (state, action) => {
        state.projectBranches = action.payload;
        state.loading = false;
      })
      .addCase(getProjectBranches.rejected, (state, action) => {
       state.projectBranches = [];
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default projectsSlice.reducer;
